// Redux-toolkit
import { useAppSelector } from './useAppStore';
import { getMembers } from '../store/team/selectors';

// Hooks
import { usePayment } from './usePayment';

// Types
import { TMember } from '../types';
import { TUpdateMemberReq } from '../types/requests';

export function useTeam() {
  const { getAmountString } = usePayment();
  const members = useAppSelector(getMembers);

  const updateMembers = (member: TUpdateMemberReq['staffMemberData']) => {
    const {
      email,
      department,
      locations,
      permissionLevel,
      position,
      name,
      phone,
      paymentAmount,
      paymentCurrencyId,
      paymentType,
      shopifyId,
      timeoffLimit,
      sickLeaveLimit,
      pinCode,
      commissionPlan,
      clockIn,
      commissionTags,
      isPromoterCommission,
    } = member;

    return members.map((member) => (member.email === email ? {
      ...member,
      department,
      locations,
      permissionLevel,
      position,
      name,
      phone,
      shopifyId,
      payment: {
        paymentAmount,
        paymentCurrencyId,
        paymentType,
      },
      timeoffLimit,
      sickLeaveLimit,
      commissionPlan,
      pinCode,
      clockIn,
      commissionTags,
      isPromoterCommission,
    } : member)) as Array<TMember>;
  };

  const getMembersByVisibility = (members: Array<TMember>) => members.map((item) => {
    const isDisplaySalary = 'payment' in item;

    return {
      ...item,
      salaryWageString: isDisplaySalary
        ? getAmountString(item)
        : '/',
    };
  });

  return {
    getMembersByVisibility,
    updateMembers,
  };
}
